import { render } from "./AppForm.vue?vue&type=template&id=49ebbaca"
import script from "./AppForm.vue?vue&type=script&lang=js"
export * from "./AppForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__